import { useEffect, useMemo, useRef, useState } from "react";
import { validatePngFile } from "./uploadValidation";

export const useImageUploadField = ({ mode, currentUrl } = {}) => {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [isRemoved, setIsRemoved] = useState(false);
  const [currentValid, setCurrentValid] = useState(false);

  const clearInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const clearSelectedFile = () => {
    setFile(null);
    setFileError("");
    setPreviewUrl("");
    clearInput();
  };

  const reset = () => {
    clearSelectedFile();
    setIsRemoved(false);
    setCurrentValid(false);
  };

  const onPickFile = (nextFile) => {
    const err = validatePngFile(nextFile);
    setFile(nextFile);
    setFileError(err || "");
    setIsRemoved(false);
    clearInput();
    return err;
  };

  const removeCurrent = () => {
    setIsRemoved(true);
    clearSelectedFile();
  };

  const canShowRemove = useMemo(() => {
    return mode === "edit" && currentValid && !isRemoved && !file;
  }, [currentValid, file, mode, isRemoved]);

  useEffect(() => {
    if (!file) {
      setPreviewUrl("");
      return;
    }

    setIsRemoved(false);
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  useEffect(() => {
    if (mode !== "edit" || !currentUrl || isRemoved || file) {
      setCurrentValid(false);
      return;
    }

    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (!cancelled) {
        setCurrentValid(true);
      }
    };
    img.onerror = () => {
      if (!cancelled) {
        setCurrentValid(false);
      }
    };
    img.src = currentUrl;

    return () => {
      cancelled = true;
    };
  }, [currentUrl, file, mode, isRemoved]);

  return {
    fileInputRef,
    file,
    fileError,
    previewUrl,
    isRemoved,
    currentValid,
    setFileError,
    onPickFile,
    clearSelectedFile,
    removeCurrent,
    reset,
    canShowRemove,
  };
};
